<template>
	<div style="overflow-y: auto;height: 100%;border-right: 1px solid rgb(238, 238, 238);" class="column">
		<div class="flex1 menus_view">
			<div class="item_view column click" :class="{ selectMenu: menusStore.currentLevel1MenuKey == item.path }"
				v-for="(item, index) in menusStore.navigationMenusList" @click="menuClick(index, item)">
				<div class="column item xy_center">
					<el-icon class="icon_view" size="24">
						<component :is="item.icon"></component>
					</el-icon>
					<div class="title_view">
						<span>{{ item.label }}</span>
					</div>
				</div>
				<div class="select_bg_view column xy_center" v-if="menusStore.currentLevel1MenuKey == item.path">
					<div class="select_bg"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useLayoutStore } from "../../../../stores/layout"
import { useMenusStore } from '../../../../stores/menus'
export default {
	setup() {
		const router = useRouter()
		const layoutStore = useLayoutStore()
		const menusStore = useMenusStore()

		return {
			router,
			layoutStore,
			menusStore
		}
	},
	data() {
		return {

		}
	},
	created() {

	},
	methods: {
		menuClick(key, item) {
			let menu = this.findPathInTree(item)
			this.router.push(menu.path)
		},
		//确定点击后跳转的路由
		findPathInTree(obj) {
			if (obj.type == 'route') {
				return obj
			}
			// 遍历children数组
			for (let child of obj.children) {
				const menu = this.findPathInTree(child);
				if (menu) {
					return menu;
				}
			}
			return null;
		}
	}
}
</script>

<style scoped lang="less">
.menus_view {
	.item_view {
		padding-top: 100%;
		position: relative;

		.item {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 100%;
			z-index: 1;
			color: #5e5e5e;

			.icon_view {
				margin-bottom: 2px;
			}

			.title_view {
				font-size: 12px;
			}
		}

	}

	.selectMenu {

		.title_view,
		.icon_view {
			color: #409eff !important;
			font-weight: 600 !important;
		}

		.title_view {
			font-size: 14px !important;
		}
	}

	.select_bg_view {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		z-index: 0;
		padding: 5px;

		.select_bg {
			background-color: rgba(64, 158, 255, .1);
			border-radius: 5px;
			width: 100%;
			height: 100%;
		}
	}
}
</style>